import React, { useState, ChangeEvent, useRef, forwardRef } from "react";
import { HStack, VStack, Select, Box, Text, Button, useToast, IconButton,
  Input, 
  InputProps,


 } from '@chakra-ui/react';
import { User, Work } from "@/pbgen/v1/main_pb";
import {client} from "@/client"
import { NavigateFunction } from "react-router-dom"; // useNavigate の型
import { bearerToken } from "@/auth";
import {
  CopyIcon,
} from "@chakra-ui/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {QRCodeCanvas} from 'qrcode.react';

import './CodeComponent.css';

interface ItemComponentProps {
  user: User;
}


export const CodeComponent: React.FC<ItemComponentProps> = ({ user }) => {
  const [localUser, setLocalUser] = useState<User>(user);
  const [showURL, setShowURL] = useState(false);
  const [codeExpirationDate, setCodeExpirationDate] = useState<Date | null>(user.optCodeExpiresAtRfc3339 && (user.optCodeExpiresAtRfc3339[0] !== "3") ? (new Date(user.optCodeExpiresAtRfc3339)) : null);





  const makeURL = () => {
    var url = "";
    if (localUser.optLoginPath) {
      url = window.location.protocol + "//" + window.location.hostname;
      if (window.location.port) {
        url = url + ":" + window.location.port
      }
      url = url + localUser.optLoginPath
    }
    return url;
  }


  const [URL, setURL] = useState<string>("");
  const toast = useToast();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(localUser.optCode ? localUser.optCode : "");
    
    toast({
      duration: 2000,
      position: "bottom",
      render: () => (
        <Box className="code_toast">クリップボードにコードがコピーされました。</Box>
      ),
    });

/*
    toast({
      duration: 2000,
      isClosable: true,
      position: "bottom",
      title: 'コピーしました',
      render: () => (
        <Box color="white" p={3} bg="blue.500" borderRadius="md">
          クリップボードにコードがコピーされました。
        </Box>
      ),
    });
    toast({
      title: 'コピーしました',
      description: "クリップボードにコードがコピーされました。",
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
*/
  };

  const handleURLCopy = async () => {
    await navigator.clipboard.writeText(URL ? URL : "");

    toast({
      duration: 2000,
      position: "bottom",
      render: () => (
        <Box className="code_toast">クリップボードにURLがコピーされました。</Box>
      ),
    });

  };

  /*
  const getExpireDateElement = (date: Date): JSX.Element => {
    return (
      <>
      <p>
      {
        "(有効期限 " + 
        (date.getFullYear() + "年" +
        (date.getMonth() + 1).toString().padStart(2, '0') + "月" +
        date.getDate().toString().padStart(2, '0') + "日") +
        [ date.getHours().toString().padStart(2, '0'),
          date.getMinutes().toString().padStart(2, '0'),
          date.getSeconds().toString().padStart(2, '0')
        ].join(':')
        + ")"
        }
      </p>
      </>
    );
  }
  */


  return <VStack align="center">
    {
      localUser.optCode ? ( 

        <>
          <VStack className="code_box">

            <HStack>
              <span className="code_text">{localUser.optCode}</span>
              <IconButton marginLeft="10px" aria-label="コピー" icon={<CopyIcon />} onClick={handleCopy} />
            </HStack>
  
            <HStack>
              <span className="code_expire_text">有効期限:</span>

              <DatePicker 
                selected={codeExpirationDate}
                onChange={(exDate: Date) => {
                  setCodeExpirationDate(exDate);
                  /*
                  if (exDate) {
                    localUser.optCodeExpiresAtRfc3339 = exDate.toISOString();
                  } else {
                    localUser.optCodeExpiresAtRfc3339 = "9999-01-01T00:00:00+09:00";
                  }
                  const resp = client.saveUser({
                    bearerToken: bearerToken(),
                    user: localUser,
                  });
                  */
                }}
                selectsEnd
                placeholderText="無期限"
                customInput={React.createElement(forwardRef<HTMLInputElement, InputProps>((props, ref) => (<Input width="240px" height="40px" fontSize="0.7g" ref={ref} {...props}/>)))}
                showTimeSelect
                dateFormat="yyyy-MM-dd HH:mm:ss"
                popperPlacement="right"
                timeFormat="HH:mm"
                strictParsing={true}
              />

              <Button onClick={async () => {
                if (codeExpirationDate) {
                  localUser.optCodeExpiresAtRfc3339 = codeExpirationDate.toISOString();
                } else {
                  localUser.optCodeExpiresAtRfc3339 = "3333-01-01T00:00:00+09:00";
                }
                const resp = client.saveUser({
                  bearerToken: bearerToken(),
                  user: localUser,
                });
                }}>更新</Button>

            </HStack>

      

            </VStack>

          <HStack>
            <Button onClick={async() => {
              if (!showURL) {
                setURL( makeURL() );
               }
              setShowURL(!showURL);
            }}
            >URL表示</Button>

            <Button onClick={async() => {
              const resp = await client.issueCode({
                bearerToken: bearerToken(),
                studentId: localUser.id,
                clear: true,
              })
              if (! resp.studentUser) {
                return
              }
              setShowURL(false);
              setLocalUser(resp.studentUser)
            }}
            >削除</Button>
    
          </HStack>

          <VStack className="code_box" display={showURL ? "flex" : "none"}>

            <HStack>
              <span className="code_expire_text">{URL}</span>
              <IconButton marginLeft="10px" aria-label="コピー" icon={<CopyIcon />} onClick={handleURLCopy} />
            </HStack>
            <QRCodeCanvas value={URL} size={120} />

        </VStack>

        </>

      ) : ( 

        <Button onClick={async () => {
          const resp = await client.issueCode({
            bearerToken: bearerToken(),
            studentId: localUser.id,
          })
          if (! resp.studentUser) {
            return
          }
          // If it is expired, assign undefined.
          if (resp.studentUser.optCodeExpiresAtRfc3339) {
            const expiresAt = new Date(resp.studentUser.optCodeExpiresAtRfc3339)
            if (expiresAt < new Date()) {
              resp.studentUser.optCode = undefined
            }
            setCodeExpirationDate(expiresAt)
          }
          setLocalUser(resp.studentUser)
        }}>発行</Button>
  

      )
    }







    </VStack>
}

